// App.js
import { BrowserRouter as Router , Routes , Route , useLocation , Navigate } from 'react-router-dom';
import React, { Suspense, useLayoutEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import FrontLayout from "./layouts/FrontLayout";
import BackLayout from "./layouts/backlayouts/BackLayout";
import { ToastProvider } from "./layouts/backlayouts/core/ToastContext";
// Pages
const HomePage = React.lazy(() => import('./pages/HomePage'));
const BiblePage = React.lazy(() => import('./pages/BiblePage'));
const BlogPage = React.lazy(() => import('./pages/BlogPage'));
const BlogDetailPage = React.lazy(() => import('./pages/BlogDetailPage'));
const FaqPage = React.lazy(() => import('./pages/FaqPage'));
const GalleryPage = React.lazy(() => import('./pages/GalleryPage'));
const PrierePage = React.lazy(() => import('./pages/PrierePage'));
const SoutienPage = React.lazy(() => import('./pages/SoutienPage'));
const SoutienDetailsPage = React.lazy(() => import('./pages/SoutienDetailsPage'));
const TermsPage = React.lazy(() => import('./pages/TermsPage'));
const ContactPage = React.lazy(() => import('./pages/ContactPage'));
const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const RegisterPage = React.lazy(() => import('./pages/RegisterPage'));
const TemplatePage = React.lazy(() => import('./pages/TemplatePage'));
const LogoutPage = React.lazy(() => import('./pages/LogoutPage'));
const Errorpage = React.lazy(() => import('./pages/Errorpage'));
const DynamicPage = React.lazy(() => import('./pages/DynamicPage'));
const PublicProfilePage = React.lazy(() => import('./pages/profil/PublicProfilePage'));
const MyProfilePage = React.lazy(() => import('./pages/profil/MyProfilePage'));
const FriendsPage = React.lazy(() => import('./pages/FriendsPage'));
const PartnerPage = React.lazy(() => import('./pages/PartnerPage'));
const GroupPage = React.lazy(() => import('./pages/GroupPage'));
const PageOfPartner = React.lazy(() => import('./pages/PageOfPartner'));
const EventsPage = React.lazy(() => import('./pages/EventsPage'));
const EventsDetailPage = React.lazy(() => import('./pages/EventsDetailPage'));
const AboutPage = React.lazy(() => import('./pages/AboutPage'));
const VerifyPartnerEmailPage = React.lazy(() => import('./pages/VerifyPartnerEmailPage'));
const OnePartnerPage = React.lazy(() => import('./pages/OnePartnerPage'));
const FormPartnerPage = React.lazy(() => import('./pages/FormPartnerPage'));
const FormMemberPage = React.lazy(() => import('./pages/FormMemberPage'));
const ForgotPasswordPage = React.lazy(() => import('./pages/ForgotPasswordPage'));
const ResetPasswordPage = React.lazy(() => import('./pages/ResetPasswordPage'));

const PricingPage = React.lazy(() => import('./pages/PricingPage'));
const PartnershipPage = React.lazy(() => import('./pages/PartnershipPage'));
const IAPricingPage = React.lazy(() => import('./pages/IAPricingPage'));
// src/App.js (en haut avec les autres imports)
const DataDeletionPage = React.lazy(() => import('./pages/legals/DataDeletionPage'));
const TransparencyPage = React.lazy(() => import('./pages/legals/TransparencyPage'));
const TermsAndPrivacyPage = React.lazy(() => import('./pages/legals/TermsAndPrivacyPage'));
const LegalNoticePage = React.lazy(() => import('./pages/legals/LegalNoticePage'));
const PrivacyPage = React.lazy(() => import('./pages/legals/PrivacyPage'));

function ScrollToTop() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
      <HelmetProvider>
        <Router>
          <Suspense fallback={<div>Chargement...</div>}>
            <ScrollToTop />
            <ToastProvider>
              {/* ton router et ton app */}
              <Routes>

                {/* Front Layout */}
                <Route element={<FrontLayout />}>

                  <Route path="/" element={<HomePage />} />
                  <Route path="/bible" element={<BiblePage />} />
                  <Route path="/blog" element={<BlogPage />} />
                  <Route path="/blog/:slug" element={<BlogDetailPage />} />
                  <Route path="/faq" element={<FaqPage />} />
                  <Route path="/gallery" element={<GalleryPage />} />
                  <Route path="/priere" element={<PrierePage />} />
                  <Route path="/soutien" element={<SoutienPage />} />
                  <Route path="/soutien/:slug" element={<SoutienDetailsPage />} />
                  <Route path="/terms-and-conditions" element={<TermsPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/logout" element={<LogoutPage />} />
                  <Route path="/template" element={<TemplatePage />} />
                  <Route path="/groups" element={<GroupPage />} />
                  <Route path="/groups/:slug" element={<GroupPage />} />
                  <Route path="/:slug" element={<DynamicPage />} />
                  <Route path="/page/:slug" element={<PageOfPartner />} />
                  <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
                  <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                  <Route path="/partners" element={<PartnerPage />} />
                  <Route path="/become-a-partner" element={<PartnershipPage />} />
                  <Route path="/become-a-partner/:slug" element={<FormPartnerPage />} />
                  <Route path="/become-a-member" element={<FormMemberPage />} />
                  <Route path="/become-a-member-old" element={<FormMemberPage />} />
                  <Route path="/partners/:slug" element={<OnePartnerPage />} />
                  <Route path="/profil" element={<Navigate to="/" replace />} />
                  <Route path="/profil/:slug" element={<PublicProfilePage />} />
                  <Route path="/my-profil/" element={<MyProfilePage />} />
                  <Route path="/myfriends" element={<FriendsPage />} />
                  <Route path="/events" element={<EventsPage />} />
                  <Route path="/events/:slug" element={<EventsDetailPage />} />
                  <Route path="/about-thesustain" element={<AboutPage />} />
                  <Route path="/pricing" element={<PricingPage />} />
                  <Route path="/ia-tools" element={<IAPricingPage />} />
                  <Route path="/partners/verify-email/:token" element={<VerifyPartnerEmailPage />} />

                  {/* Pages légales */}
                  <Route path="/transparency" element={<TransparencyPage />} />
                  <Route path="/data-deletion" element={<DataDeletionPage />} />
                  <Route path="/legal-notis" element={<LegalNoticePage />} />
                  <Route path="/terms-and-privacy" element={<TermsAndPrivacyPage />} />
                  <Route path="/privacy" element={<PrivacyPage />} />

                </Route>

                {/* Back Layout - admin pages */}
                {/* --- Ajout BackLayout --- */}
                <Route path="/dashboard/*" element={<BackLayout />} />

                {/* ---<Route path="/dashboard" element={<BackVenixLayout />}>

                <Route path="prayer" element={<PrayerPage />} />

              </Route>*/}



                {/* Fallback 404 */}
                <Route path="*" element={<Errorpage />} />
              </Routes>
            </ToastProvider>
          </Suspense>
        </Router>
      </HelmetProvider>
  );
}

export default App;
